import React, { useState, useEffect } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Box,
  OutlinedInput,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Theme, { useStyles } from "./Theme.js";

const Satisfaction = (props) => {
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const classes = useStyles();

  useEffect(() => {
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    if (props.result.ressenti) {
      setValue(props.result.ressenti);
      setValue2(props.result.comment);
      // setchecked(props.result.type_picto);
    }
    props.setAuthorization(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    let newResult = props.result;
    newResult["comment"] = "";
    props.setResult(newResult);
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["ressenti"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };
  const handleChange2 = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue2(event.target.value2);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["comment"] = event.target.value2;
    props.setResult(newResult);
  };
  return (
    <FormControl component="fieldset" style={{ width: "100%" }}>
      <FormLabel component="legend">
        {`Quel est votre ressenti, par rapport au sujet évoqué ?`}
      </FormLabel>

      <RadioGroup
        aria-label="typeSignal"
        name="signal1"
        value={value}
        onChange={handleChange}
        style={{
          flexDirection: "row",
          textAlign: "left",
        }}
      >
        <Box className={classes.emojisColumn}>
          <FormControlLabel
            value="wahou"
            control={<Radio />}
            label="🤩 Wahou !"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="coup_de_coeur"
            control={<Radio />}
            label="🥰 Coup de coeur"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="content"
            control={<Radio />}
            label="😊 Content"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="surpris"
            control={<Radio />}
            label="😮 Surpris"
            style={{ margin: 0 }}
          />
        </Box>
        <Box className={classes.emojisColumn}>
          <FormControlLabel
            value="triste"
            control={<Radio />}
            label="😢 Triste"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="déçu"
            control={<Radio />}
            label="😒 Déçu"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="dubitatif"
            control={<Radio />}
            label="😕 Dubitatif"
            style={{ margin: 0 }}
          />
          <FormControlLabel
            value="colère"
            control={<Radio />}
            label="😡 En colère"
            style={{ margin: 0 }}
          />
        </Box>
      </RadioGroup>
      <br />
      <Box style={{ maxWidth: "88%", margin: "auto" }}>
        <Typography variant="body2">
          Ajoutez vos observations (optionnel)
        </Typography>
        <OutlinedInput
          onChange={handleChange2}
          className={classes.commentBox}
          multiline
          rows={6}
          value={value2}
        />
      </Box>
    </FormControl>
  );
};

export default Satisfaction;
